{
	"add": {
		"button": "Aggiungi editore",
		"confirm": "Continua",
		"duplicate": "«{{name}}» è già in elenco.",
		"hint": "Serve solo per una casa editrice che non compare ancora in nessun documento: tutte le altre sono già in elenco. Scrivi il nome esattamente come su Mr.Book.",
		"open_existing": "Aprilo",
		"placeholder": "Nome della casa editrice",
		"title": "Aggiungi editore"
	},
	"change": {
		"gained": "Esclusiva acquisita nel {{year}}",
		"gained_hint": "Nel {{previous}} lo vendevamo all'ingrosso: le quantità vengono riscalate sulle vendite degli editori in esclusiva.",
		"gained_short": "acquisita nel {{year}}",
		"legend": "Cambio di canale",
		"lost": "Esclusiva persa nel {{year}}",
		"lost_hint": "Nel {{previous}} eravamo esclusivisti: le quantità vengono riscalate sulle vendite degli editori all'ingrosso.",
		"lost_short": "persa nel {{year}}",
		"none": "Nessun cambio",
		"none_hint": "Il canale è lo stesso della campagna {{previous}}."
	},
	"channel": {
		"all": "Tutte",
		"esclusiva": "Esclusiva",
		"ingrosso": "Ingrosso"
	},
	"columns": {
		"channel": "Canale",
		"publisher": "Casa editrice",
		"sold": "Venduto"
	},
	"filter_region": "Regione",
	"no_document": "L'elenco arriva dall'ultimo documento generato. Generane uno e le case editrici compariranno qui.",
	"no_match": "Nessuna casa editrice corrisponde ai filtri.",
	"page_description": "Dove Mantegna è distributore esclusivo, regione per regione. Tutte le altre case editrici sono a ingrosso. Le modifiche valgono dai prossimi documenti generati.",
	"page_title": "Esclusive",
	"region_header_title": "Editori in esclusiva in {{region}}: {{count}}",
	"region_mark": "Esclusiva in {{region}}",
	"regions": {
		"abruzzo": "Abruzzo",
		"basilicata": "Basilicata",
		"calabria": "Calabria",
		"campania": "Campania",
		"lazio": "Lazio",
		"molise": "Molise",
		"puglia": "Puglia",
		"sardegna": "Sardegna",
		"sicilia": "Sicilia",
		"toscana": "Toscana",
		"umbria": "Umbria"
	},
	"search_placeholder": "Cerca una casa editrice",
	"sheet": {
		"add": "Aggiungi",
		"channel": "Canale",
		"copy_from": "Copia da un altro editore",
		"copy_from_label": "Le combinazioni già in uso, dalla più diffusa",
		"copy_like": "Come {{name}}",
		"copy_like_others_one": "Come {{name}} e un altro",
		"copy_like_others_other": "Come {{name}} e altri {{count}}",
		"effective": "Vale dai prossimi documenti generati.",
		"esclusiva_hint": "Mantegna è distributore esclusivo in almeno una regione. Scorta di sicurezza più alta.",
		"gains": "Salvando, {{name}} passa da ingrosso a esclusiva.",
		"ingrosso_hint": "Nessuna regione in esclusiva. Scorta di sicurezza standard.",
		"loses": "Salvando, {{name}} perde l'esclusiva in {{regions}} e passa a ingrosso.",
		"new_publisher": "Non compare ancora in nessun documento generato.",
		"not_in_document": "Non compare nell'ultimo documento generato.",
		"regions": "Regioni in esclusiva",
		"regions_count": "{{count}} di {{total}}",
		"regions_required": "Scegli almeno una regione, oppure scegli Ingrosso.",
		"regions_required_new": "Scegli almeno una regione.",
		"save": "Salva",
		"sold": "Venduto nella campagna precedente: {{sold}} copie"
	},
	"toast": {
		"change_updated": "Cambio di canale di {{name}} aggiornato. Vale dai prossimi documenti generati.",
		"regions_updated": "Regioni di {{name}} aggiornate. Valgono dai prossimi documenti generati.",
		"to_esclusiva": "{{name}} passa a esclusiva. Vale dai prossimi documenti generati.",
		"to_ingrosso": "{{name}} passa a ingrosso. Vale dai prossimi documenti generati.",
		"undo": "Annulla",
		"undone": "Modifica annullata."
	}
}
